<template>
  <div ref="internal-resistance-scatter-container" class="internal-resistance-scatter-container">
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'InternalResistanceScatter',
    methods: {
        getOption() {
            const option = {
                legend: {
                    top: 10,
                    data: [{
                        name: '内阻',
                        lineStyle: {
                            color: 'rgba(41, 150, 157, 1)'
                        }
                    }],
                    textStyle: {
                        color: '#01AAF2',
                        fontSize: 16
                    },
                    right: 20,
                },
                tooltip: {
                    position: 'top',
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                xAxis: {
                    data: [
                        '2021/7/12 0:00',
                        '2021/7/12 1:00',
                        '2021/7/12 2:00',
                        '2021/7/12 3:00',
                        '2021/7/12 4:00',
                        '2021/7/12 5:00',
                        '2021/7/12 6:00',
                        '2021/7/12 7:00',
                        '2021/7/12 8:00',
                        '2021/7/12 9:00',
                        '2021/7/12 10:00',
                        '2021/7/12 11:00',
                        '2021/7/12 12:00',
                        '2021/7/12 13:00',
                        '2021/7/12 14:00',
                        '2021/7/12 15:00',
                        '2021/7/12 16:00',
                        '2021/7/12 17:00',
                        '2021/7/12 18:00',
                        '2021/7/12 19:00',
                        '2021/7/12 20:00',
                        '2021/7/12 21:00',
                        '2021/7/12 22:00',
                        '2021/7/12 23:00'
                    ],
                    axisLabel: {
                        color: '#E3F0FF',
                        fontSize: 12,
                        fontWeight: 700
                    },  
                    axisLine: {
                        lineStyle: {
                            color: '#0C89AD',
                            opacity: 0.3
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#094B85'],
                            opacity: 0.3
                        }
                    }
                },
                yAxis: {
                    axisLabel: {
                        color: '#E3F0FF',
                        fontSize: 12,
                        fontWeight: 700
                    }, 
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#0C89AD',
                            opacity: 0.3
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#094B85'],
                            opacity: 0.3
                        }
                    }
                },
                grid: {
                    top: 40,
                    bottom: 40,
                    left: 50
                },
                series: [{
                    name: '内阻',
                    symbolSize: 10,
                    data: [
                        [0, 0.6],
                        [1, 0.48],
                        [2, 0.402],
                        [3, 0.462],
                        [4, 0.487],
                        [5, 0.487],
                        [6, 0.487],
                        [7, 0.487],
                        [8, 0.487],
                        [9, 0.487],
                        [10, 0.487],
                        [11, 0.487],
                        [12, 0.451],
                        [13, 0.418],
                        [14, 0.412],
                        [15, 0.374],
                        [16, 0.374],
                        [17, 0.374],
                        [18, 0.395],
                        [19, 0.396],
                        [20, 0.396],
                        [21, 0.404],
                        [22, 0.464],
                        [23, 0.524],
                    ],
                    type: 'scatter',
                    itemStyle: {
                        color: 'rgba(41, 150, 157, 1)'
                    }
                }]
            };
            return option;
        }
    },
    mounted() {
        const chartDom = this.$refs['internal-resistance-scatter-container'];
        const chart = echarts.init(chartDom);
        this.chart = chart;
        this.chart.setOption(this.getOption());
    }
}
</script>

<style lang="less">
    .internal-resistance-scatter-container {
        width: 100%;
        height: 100%;
    }
</style>